
window.$ = window.jQuery;

$(".tab__trigger").on("click", function(e) {
    e.preventDefault();
    const target = e.currentTarget;
    if (!$(target).hasClass("button-v3--disable")) return;
  
    const index = $(target).data("index");
  
    $(".tab__trigger")
      .not(".button-v3--disable")
      .addClass("button-v3--disable")
      .removeClass("button-v3--active");
  
    $(target).removeClass("button-v3--disable").addClass("button-v3--active");
  
    $(target)
      .parents(".tab")
      .find(".tab-inner")
      .not(".tab-inner__disable")
      .fadeOut();
  
    const exitEl = $(target)
      .parents(".tab")
      .find(".tab-inner")
      .not(".tab-inner__disable");
  
    const enterEl = $(target)
      .parents(".tab")
      .find(`.tab-inner[data-index="${index}"]`);
  
    $(exitEl).animate(
      {
        opacity: 0,
      },
      400,
      "swing"
    );
  
    setTimeout(() => {
      jQuery(exitEl).addClass("tab-inner__disable");
  
      $(enterEl).animate(
        {
          opacity: 1,
          display: "initial",
        },
        400,
        "swing"
      );
  
      $(enterEl).removeClass("tab-inner__disable");
  
      $(enterEl).show();
    }, 300);
  });
  